<div class="nomination-scroll">
  <div class="nomination-page">

    <!-- INTESTAZIONE -->
    <div class="nomination-toolbar">
      <div class="nomination-toolbar-text">
        <h2>Gestione candidature</h2>
        <p>
          Crea e gestisci le candidature, visualizza gli iscritti
          e aggiorna lo stato delle richieste.
        </p>
      </div>

      <p-button
        label="Nuova candidatura"
        icon="pi pi-plus"
        styleClass="p-button-primary nomination-new-button"
        (onClick)="createNewNomination()"
      ></p-button>
    </div>

    <!-- CREAZIONE NUOVA CANDIDATURA -->
    <div class="nomination-card nomination-creation-card" *ngIf="creating">

      <div class="nomination-card-header">
        <div class="nomination-card-heading">
          <div class="nomination-heading-icon">
            <i class="pi pi-plus-circle"></i>
          </div>

          <div>
            <h3>Nuova candidatura</h3>
            <span>Compila i dati della proposta</span>
          </div>
        </div>
      </div>

      <div class="nomination-card-body">

        <div class="nomination-form-grid">

          <div class="nomination-field">
            <label for="new-nomination-title">Titolo candidatura</label>

            <input
              id="new-nomination-title"
              pInputText
              type="text"
              [(ngModel)]="creating.title"
              placeholder="Inserisci il titolo"
            />
          </div>

          <div class="nomination-field">
            <label for="new-nomination-event">Evento</label>

            <input
              id="new-nomination-event"
              pInputText
              type="text"
              [(ngModel)]="creating.eventName"
              placeholder="Inserisci il nome dell'evento"
            />
          </div>

          <div class="nomination-field nomination-field-full">
            <label for="new-nomination-description">Descrizione</label>

            <textarea
              id="new-nomination-description"
              pInputTextarea
              [(ngModel)]="creating.description"
              rows="4"
              [autoResize]="true"
              placeholder="Descrivi la candidatura"
            ></textarea>
          </div>

          <div class="nomination-field">
            <label>Valido da</label>

            <p-calendar
              [(ngModel)]="creating.startDate"
              dateFormat="dd/mm/yy"
              [showTime]="true"
              [showIcon]="true"
              [showButtonBar]="true"
              [touchUI]="true"
              appendTo="body"
            ></p-calendar>
          </div>

          <div class="nomination-field">
            <label>Valido fino a</label>

            <p-calendar
              [(ngModel)]="creating.endDate"
              dateFormat="dd/mm/yy"
              [showTime]="true"
              [showIcon]="true"
              [showButtonBar]="true"
              [touchUI]="true"
              appendTo="body"
            ></p-calendar>
          </div>

        </div>

        <div class="nomination-users-selection">
          <div class="nomination-users-info">
            <i class="pi pi-users"></i>

            <div>
              <strong>Iscritti selezionati</strong>
              <span>
                {{ userIds.length }}
                {{ userIds.length === 1 ? 'utente' : 'utenti' }}
              </span>
            </div>
          </div>

          <p-button
            label="Seleziona iscritti"
            icon="pi pi-users"
            styleClass="p-button-outlined"
            (onClick)="assignUsers()"
          ></p-button>
        </div>

        <div class="nomination-form-actions">

          <p-button
            label="Annulla"
            icon="pi pi-times"
            styleClass="p-button-outlined p-button-danger"
            (onClick)="cancelCreation()"
          ></p-button>

          <p-button
            label="Crea candidatura"
            icon="pi pi-check"
            styleClass="p-button-success"
            [disabled]="!creating.title || !creating.eventName"
            (onClick)="createNomination()"
          ></p-button>

        </div>

      </div>
    </div>

    <!-- STATO VUOTO -->
    <div
      class="nomination-empty"
      *ngIf="nominations.length === 0 && !creating"
    >
      <i class="pi pi-inbox"></i>
      <h3>Nessuna candidatura presente</h3>
      <p>
        Non sono ancora state create candidature.
        Utilizza il pulsante in alto per aggiungerne una.
      </p>
    </div>

    <!-- ELENCO CANDIDATURE -->
    <div class="nomination-list">

      <div
        class="nomination-card"
        *ngFor="let prop of nominations"
      >

        <!-- VISUALIZZAZIONE -->
        <ng-container *ngIf="!editingNominations[prop.proposalId!]">

          <div class="nomination-card-header">

            <div class="nomination-card-heading">

              <button
                type="button"
                class="nomination-expand-button"
                (click)="prop.expanded = !prop.expanded"
                [attr.aria-expanded]="!!prop.expanded"
                [attr.aria-label]="prop.expanded ? 'Chiudi dettagli' : 'Apri dettagli'"
              >
                <i
                  class="pi"
                  [ngClass]="prop.expanded ? 'pi-chevron-down' : 'pi-chevron-right'"
                ></i>
              </button>

              <div class="nomination-heading-text">
                <h3>{{ prop.title }}</h3>

                <span class="nomination-event-label">
                  <i class="pi pi-calendar"></i>
                  {{ prop.eventName }}
                </span>
              </div>

            </div>

            <div class="nomination-header-actions">

              <p-button
                icon="pi pi-pencil"
                label="Modifica"
                styleClass="p-button-outlined p-button-primary"
                (onClick)="startEditing(prop)"
              ></p-button>

              <p-button
                icon="pi pi-trash"
                label="Elimina"
                styleClass="p-button-outlined p-button-danger"
                (onClick)="removeNomination(prop)"
              ></p-button>

            </div>

          </div>

          <!-- INFORMAZIONI PRINCIPALI -->
          <div class="nomination-summary">

            <div class="nomination-summary-item">
              <div class="nomination-summary-icon">
                <i class="pi pi-calendar-plus"></i>
              </div>

              <div>
                <span class="nomination-summary-label">
                  Inizio validità
                </span>

                <strong>
                  {{ prop.startDate | date:'dd/MM/yyyy HH:mm' }}
                </strong>
              </div>
            </div>

            <div class="nomination-summary-item">
              <div class="nomination-summary-icon">
                <i class="pi pi-calendar-times"></i>
              </div>

              <div>
                <span class="nomination-summary-label">
                  Fine validità
                </span>

                <strong>
                  {{ prop.endDate | date:'dd/MM/yyyy HH:mm' }}
                </strong>
              </div>
            </div>

            <div class="nomination-summary-item">
              <div class="nomination-summary-icon">
                <i class="pi pi-users"></i>
              </div>

              <div>
                <span class="nomination-summary-label">
                  Candidature ricevute
                </span>

                <strong>
                  {{ (prop.nominations || []).length }}
                </strong>
              </div>
            </div>

          </div>

          <!-- DETTAGLI ESPANDIBILI -->
          <div class="nomination-details" *ngIf="prop.expanded">

            <div
              class="nomination-description-container"
              *ngIf="prop.description"
            >
              <h4>
                <i class="pi pi-align-left"></i>
                Descrizione
              </h4>

              <p class="nomination-description">
                {{ prop.description }}
              </p>
            </div>

            <div class="nomination-table-header">
              <h4>
                <i class="pi pi-users"></i>
                Elenco candidature
              </h4>

              <p-button
                icon="pi pi-refresh"
                label="Aggiorna"
                styleClass="p-button-outlined p-button-sm"
                (onClick)="loadNominations()"
              ></p-button>
            </div>

            <div class="nomination-table-container">

              <p-table
                [value]="prop.nominations || []"
                styleClass="p-datatable-sm nomination-table"
                [responsiveLayout]="'scroll'"
              >

                <ng-template pTemplate="header">
                  <tr>
                    <th>Iscritto</th>
                    <th>Data candidatura</th>
                    <th>Stato</th>
                    <th>Azioni</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-request>
                  <tr>

                    <td>
                      <div class="nomination-subscriber">
                        <i class="pi pi-user"></i>

                        <strong *ngIf="request.subscriber">
                          {{ request.subscriber.name }}
                          {{ request.subscriber.lastName }}
                        </strong>
                      </div>
                    </td>

                    <td>
                      {{ request.requestDate | date:'dd/MM/yyyy' }}
                    </td>

                    <td>
                      <span
                        class="nomination-status"
                        [ngClass]="{
                          'status-accepted':
                            request.status === NominationStatus.ACCEPTED,

                          'status-rejected':
                            request.status === NominationStatus.REJECTED,

                          'status-pending':
                            request.status === NominationStatus.PENDING,

                          'status-cancelled':
                            request.status === NominationStatus.CANCELLED,

                          'status-other':
                            request.status === NominationStatus.REQUESTED_ANOTHER
                        }"
                      >
                        {{ nominationDictionary[request.status] }}
                      </span>
                    </td>

                    <td>
                      <div class="nomination-row-actions">

                        <ng-container
                          *ngIf="request.status === NominationStatus.PENDING"
                        >

                          <p-button
                            icon="pi pi-check"
                            severity="success"
                            [outlined]="true"
                            (onClick)="acceptNomination(
                              request.proposalId,
                              request.subscriber.subscriberId
                            )"
                          ></p-button>

                          <p-button
                            icon="pi pi-ban"
                            severity="warning"
                            [outlined]="true"
                            (onClick)="rejectNomination(
                              request.proposalId,
                              request.subscriber.subscriberId
                            )"
                          ></p-button>

                          <p-button
                            icon="pi pi-trash"
                            severity="danger"
                            [outlined]="true"
                            (onClick)="cancelNomination(
                              request.proposalId,
                              request.subscriber.subscriberId
                            )"
                          ></p-button>

                        </ng-container>

                        <span
                          class="nomination-no-actions"
                          *ngIf="request.status !== NominationStatus.PENDING"
                        >
                          —
                        </span>

                      </div>
                    </td>

                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="4">
                      <div class="nomination-table-empty">
                        <i class="pi pi-info-circle"></i>
                        Nessuna candidatura ricevuta.
                      </div>
                    </td>
                  </tr>
                </ng-template>

              </p-table>

            </div>

          </div>

        </ng-container>

        <!-- MODIFICA -->
        <ng-container *ngIf="editingNominations[prop.proposalId!]">

          <div class="nomination-card-header">
            <div class="nomination-card-heading">

              <div class="nomination-heading-icon">
                <i class="pi pi-pencil"></i>
              </div>

              <div>
                <h3>Modifica candidatura</h3>
                <span>Aggiorna i dati della proposta</span>
              </div>

            </div>
          </div>

          <div class="nomination-card-body">

            <div class="nomination-form-grid">

              <div class="nomination-field">
                <label>Titolo candidatura</label>

                <input
                  pInputText
                  type="text"
                  [(ngModel)]="prop.title"
                />
              </div>

              <div class="nomination-field">
                <label>Evento</label>

                <input
                  pInputText
                  type="text"
                  [(ngModel)]="prop.eventName"
                />
              </div>

              <div class="nomination-field nomination-field-full">
                <label>Descrizione</label>

                <textarea
                  pInputTextarea
                  [(ngModel)]="prop.description"
                  rows="4"
                  [autoResize]="true"
                ></textarea>
              </div>

              <div class="nomination-field">
                <label>Valido da</label>

                <p-calendar
                  [(ngModel)]="prop.startDate"
                  dateFormat="dd/mm/yy"
                  [showTime]="true"
                  [showIcon]="true"
                  [showButtonBar]="true"
                  [touchUI]="true"
                  appendTo="body"
                ></p-calendar>
              </div>

              <div class="nomination-field">
                <label>Valido fino a</label>

                <p-calendar
                  [(ngModel)]="prop.endDate"
                  dateFormat="dd/mm/yy"
                  [showTime]="true"
                  [showIcon]="true"
                  [showButtonBar]="true"
                  [touchUI]="true"
                  appendTo="body"
                ></p-calendar>
              </div>

            </div>

            <div class="nomination-form-actions">

              <p-button
                label="Annulla"
                icon="pi pi-times"
                styleClass="p-button-outlined p-button-danger"
                (onClick)="cancelEditing(prop)"
              ></p-button>

              <p-button
                label="Salva modifiche"
                icon="pi pi-save"
                styleClass="p-button-success"
                (onClick)="modifyNomination(prop)"
              ></p-button>

            </div>

          </div>

        </ng-container>

      </div>

    </div>

  </div>
</div>